import { useEffect, useState } from "react";

const navLinks = [
  { label: "Products", href: "#products" },
  { label: "Solutions", href: "#solutions" },
  { label: "Pricing", href: "#pricing" },
  { label: "Docs", href: "#docs" },
  { label: "Blog", href: "#blog" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/70 backdrop-blur-xl border-b border-zinc-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-6 md:px-10">
        {/* Logo */}
        <a
          href="/"
          className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <span
            className={`flex h-8 w-8 items-center justify-center rounded-md transition-colors ${
              scrolled ? "bg-zinc-900 text-white" : "bg-white/90 text-zinc-900"
            }`}
          >
            <i className="ri-shape-line text-lg"></i>
          </span>
          <span
            className={`text-base font-semibold tracking-tight ${
              scrolled ? "text-zinc-900" : "text-white"
            }`}
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Prism
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                scrolled
                  ? "text-zinc-700 hover:text-zinc-950"
                  : "text-white/80 hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* Desktop actions */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="#signin"
            className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
              scrolled ? "text-zinc-700 hover:text-zinc-950" : "text-white/85 hover:text-white"
            }`}
          >
            Sign in
          </a>
          <a
            href="#get-started"
            className="group inline-flex items-center gap-2 rounded-md bg-zinc-900 px-4 py-2 text-sm font-medium text-white whitespace-nowrap cursor-pointer hover:bg-zinc-800 transition-colors"
          >
            Get Started
            <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5"></i>
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setMobileOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? "text-zinc-900" : "text-white"
          }`}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen ? (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-zinc-200/70">
          <nav className="flex flex-col px-6 py-4 gap-4">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setMobileOpen(false)}
                className="text-sm font-medium text-zinc-800 cursor-pointer whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
            <div className="flex flex-col gap-3 pt-2 border-t border-zinc-200">
              <a
                href="#signin"
                className="text-sm font-medium text-zinc-700 cursor-pointer whitespace-nowrap"
              >
                Sign in
              </a>
              <a
                href="#get-started"
                className="inline-flex items-center justify-center rounded-md bg-zinc-900 px-4 py-2 text-sm font-medium text-white whitespace-nowrap cursor-pointer"
              >
                Get Started
              </a>
            </div>
          </nav>
        </div>
      ) : null}
    </header>
  );
}